import type { EventDto, EventFormat, EventSlidesDto } from '@pb/shared';
import { asList, del, get, patch, post, put } from './client';

export interface EventFields {
  title: string;
  date: string;
  start_time: string | null;
  format: EventFormat;
  location: string;
  audience: string;
  attendees: string[];
  notes: string;
}

export const listEvents = async (projectId: number) =>
  asList(await get<EventDto[] | { items: EventDto[] }>(`/projects/${projectId}/events`));
export const createEvent = (projectId: number, input: EventFields & { presentation_ids?: number[] }) =>
  post<EventDto>(`/projects/${projectId}/events`, input);
export const getEvent = (id: number) => get<EventDto>(`/events/${id}`);
export const updateEvent = (id: number, input: Partial<EventFields>) => patch<EventDto>(`/events/${id}`, input);
export const setEventPresentations = (id: number, presentationIds: number[]) =>
  put<EventDto>(`/events/${id}/presentations`, { presentation_ids: presentationIds });
export const generateEvent = (id: number) => post<unknown>(`/events/${id}/generate`, {});
export const markEventHeld = (id: number, confirm: string) => post<unknown>(`/events/${id}/held`, { confirm });
export const deleteEvent = (id: number, confirm: string) => del<unknown>(`/events/${id}`, { confirm });
export const getEventSlides = (id: number) => get<EventSlidesDto>(`/events/${id}/slides`);
